<div *ngIf="!netsolinS.loaded">
  <div *ngIf="oapp.netsolin_ini.solonetsolin" class="img-loader">
    <img src="assets/images/netsolin-logo.jpeg">
  </div>
  <div *ngIf="!oapp.netsolin_ini.solonetsolin" class="img-loader">
    <img src="assets/images/vivelgo-logo.svg" style="height: 45rem; width: 45rem;">
  </div>
  <div class="container-loading">
    <div class="row">
      <div class="col-2">
        <div class="spinner-grow text-custom" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="col-2">
        <div class="spinner-grow text-custom" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="col-2">
        <div class="spinner-grow text-custom" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="col-2">
        <div class="spinner-grow text-custom" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="col-2">
        <div class="spinner-grow text-custom" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="col-2">
        <div class="spinner-grow text-custom" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>  
</div>
<div class="dark-body-only" *ngIf="netsolinS.loaded">
  <!-- page-wrapper Start-->
  <div class="page-wrapper" [ngClass]="customizer.data.settings.sidebar.type" id="canvas-bookmark">
    <app-header></app-header>
    <!-- Page Body Start-->
    <div class="page-body-wrapper" [ngClass]="customizer.data.settings.sidebar.body_type">
      <div class="page-sidebar" id="pages-sidebar" [class.open]="navServices.collapseSidebar"
        [ngClass]="customizer.data.settings.sidebar_backround">
        <div class="sidebar-cont">
          <app-sidebar></app-sidebar>
        </div>
      </div>
      <div class="user-sidebar-cont" [ngClass]="{'hide' : navServices.collapseUserSidebar}">
        <app-user-sidebar></app-user-sidebar>
      </div>
      <div class="page-body w-per-100">
        <!-- <app-breadcrumb></app-breadcrumb> -->
        <main>
          <router-outlet></router-outlet>
        </main>
      </div>
      <!-- footer start-->
      <footer class="footer">
        <app-footer></app-footer>
      </footer>
      <!-- footer End-->
    </div>
    <!-- Page Body End-->
  </div>
  <!-- page-wrapper End-->
</div>
<!-- Configuracion de Sidebar estilos -->
<!-- <app-customizer></app-customizer>  -->

<div class="modal fade" id="change_property" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="change_propertyLabel" aria-hidden="true">
  <div class="modal-dialog  modal-lg modal-dialog-centered modal-dialog-scrollable" id="change_property-modal">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title color-white" id="change_propertyLabel">
          Selecciona a que empresa deseas Ingresar
        </h5>
        <button type="button" class="close color-white" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-per-1">
        <div class="row no-gutters m-px-0">
          <div class="col-4 property" *ngFor="let ph of globalS.empresas | keyvalue">
            <div *ngIf="buscaNit(ph.key)" class="cont" [ngClass]="{'active':ph.key==globalS.empresaId}" (click)="globalS.updateEmpresa(ph.key); netsolinS.loaded = false" data-dismiss="modal">
              <div class="circle"></div>
              <div class="name">
                {{ph.value?.nombre}}
              </div>
              <div class="subname">
                {{ph.key}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>